import React from 'react';
import { EVENT_STATUS, MARKET_STATUS, SPORTS } from 'constants/appConfig';
import {
    EventColMeta,
    EventColRight,
    EventMainMarkets,
    EventName,
    EventNames,
    EventScoreBySets,
    EventScoreCol,
    LinkShowAllMarkets,
    LiveScoreTime,
    LiveSreamIcon,
    ViewEventListItemBox,
} from './styled';
import ViewMainMarkets from '../../components/ViewMainMarkets/ViewMainMarkets';
import liveIcon from 'images/icons/live_stream.svg';
import { getMarketCountLabel, getTeamName, openGamePage } from './helper';
import { detectMobile } from '../../utils/UiHelper';
import { useContainerWidth } from '../../contexts/ContainerWidthContext';

const LiveEventListItem = ({ ev, marketList, header, userId }) => {
    const setScoresEventIds = [
        SPORTS.TENNIS,
        SPORTS.BADMINTON,
        SPORTS.TABLE_TENNIS,
        SPORTS.VOLLEYBALL,
        SPORTS.BEACH_VOLLEY,
    ];
    const isMobile = detectMobile();
    const contentWidth = useContainerWidth();

    const _getScoreBySets = (ev) => {
        if (!ev.liveScore) {
            return (
                <EventScoreBySets>
                    <EventScoreCol>
                        <div className="home">0</div>
                        <div className="away">0</div>
                    </EventScoreCol>
                </EventScoreBySets>
            );
        }

        if (
            ev.liveScore.scorePartList &&
            ev.liveScore.scorePartList.length > 0
        ) {
            const currentSet =
                ev.liveScore.scorePartList[
                    ev.liveScore.scorePartList.length - 1
                ];
            const homeGameScore =
                ev.liveScore.extraInfo && ev.liveScore.extraInfo.HomeGameScore
                    ? ev.liveScore.extraInfo.HomeGameScore
                    : null;
            const awayGameScore =
                ev.liveScore.extraInfo && ev.liveScore.extraInfo.AwayGameScore
                    ? ev.liveScore.extraInfo.AwayGameScore
                    : null;
            const [homeScore, awayScore] = currentSet.score.split(':');

            return (
                <EventScoreBySets>
                    <EventScoreCol>
                        <div className="home">
                            {ev.liveScore && ev.liveScore.homeScore}
                        </div>
                        <div className="away">
                            {ev.liveScore && ev.liveScore.awayScore}
                        </div>
                    </EventScoreCol>
                    <EventScoreCol $withoutBg={true}>
                        <div className="home" title={currentSet.part}>
                            {homeScore}
                        </div>
                        <div className="away" title={currentSet.part}>
                            {awayScore}
                        </div>
                    </EventScoreCol>
                    {ev.sportId === SPORTS.TENNIS &&
                        homeGameScore &&
                        awayGameScore && (
                            <EventScoreCol $withoutBg={true}>
                                <div className="home" title={currentSet.part}>
                                    {homeGameScore}
                                </div>
                                <div className="away" title={currentSet.part}>
                                    {awayGameScore}
                                </div>
                            </EventScoreCol>
                        )}
                </EventScoreBySets>
            );
        }

        if (ev.sportId === SPORTS.TABLE_TENNIS) {
            const setScores = (ev.liveScore.partScores || '').split(' - ');
            const lastScore = setScores[setScores.length - 1] || '0:0';
            const [homeSetScore, awaySetScore] = lastScore.split(':');
            return (
                <EventScoreBySets>
                    <EventScoreCol>
                        <div className="home">
                            {ev.liveScore && ev.liveScore.homeScore}
                        </div>
                        <div className="away">
                            {ev.liveScore && ev.liveScore.awayScore}
                        </div>
                    </EventScoreCol>
                    {!ev.liveScore.partScores ? (
                        <EventScoreCol $withoutBg={true}>
                            <div className="home">-</div>
                            <div className="away">-</div>
                        </EventScoreCol>
                    ) : (
                        <EventScoreCol $withoutBg={true}>
                            <div className="home">{homeSetScore}</div>
                            <div className="away">{awaySetScore}</div>
                        </EventScoreCol>
                    )}
                </EventScoreBySets>
            );
        }
        return (
            <EventScoreBySets>
                <EventScoreCol>
                    <div className="home">
                        {ev.liveScore && ev.liveScore.homeScore}
                    </div>
                    <div className="away">
                        {ev.liveScore && ev.liveScore.awayScore}
                    </div>
                </EventScoreCol>
            </EventScoreBySets>
        );
    };

    const getScore = (ev) => {
        if (!setScoresEventIds.includes(ev.sportId)) {
            return (
                <EventScoreCol>
                    <div className="home">
                        {ev?.liveScore ? ev.liveScore.homeScore : 0}
                    </div>
                    <div className="away">
                        {ev?.liveScore ? ev.liveScore.awayScore : 0}
                    </div>
                </EventScoreCol>
            );
        } else {
            return _getScoreBySets(ev);
        }
    };

    const getLiveTime = (ev) => {
        const time = ev?.liveScore?.time;
        const status = ev?.liveScore?.status;

        if (ev.sportId === SPORTS.FOOTBALL) {
            if (time && time !== -1) {
                if (time === 45 && status === 'paused') {
                    return 'HT';
                }
                return `${time}'`;
            }
        }

        if ((time && time !== -1) || time === 0) {
            return `${time}'`;
        }

        return 'Live';
    };

    const isLivePageLocation = () => {
        return window.location.pathname === '/live';
    };

    const marketCountLabel = getMarketCountLabel(ev, isMobile, contentWidth);
    const liveTime = getLiveTime(ev);
    const score = getScore(ev);

    return (
        <ViewEventListItemBox $isMobile={isMobile}>
            <EventColMeta $isMobile={isMobile} $contentWidth={contentWidth}>
                {!isMobile && (
                    <LiveScoreTime $isMobile={isMobile}>
                        {liveTime}
                    </LiveScoreTime>
                )}

                <EventNames
                    onClick={() => openGamePage(ev, userId)}
                    $isMobile={isMobile}
                >
                    <EventName>{getTeamName(ev, '1')}</EventName>
                    <EventName>{getTeamName(ev, '2')}</EventName>
                </EventNames>

                {score}
            </EventColMeta>

            <EventMainMarkets
                $isMobile={isMobile}
                $contentWidth={contentWidth}
                $width={isLivePageLocation() ? '50%' : '55%'}
            >
                <ViewMainMarkets
                    disabled={
                        ev.status !== EVENT_STATUS.IN_PROGRESS ||
                        (marketList?.[0] &&
                            marketList?.[0].status !== MARKET_STATUS.ACTIVE)
                    }
                    ev={ev}
                    market={marketList?.[0]}
                    live={ev.live ? '1' : '0'}
                    header={header}
                />
            </EventMainMarkets>

            <EventColRight $isMobile={isMobile}>
                {isMobile && (
                    <>
                        <LiveScoreTime $isMobile={isMobile}>
                            {liveTime}
                        </LiveScoreTime>
                        {marketList &&
                            marketList[0] &&
                            marketList[0].freeText && (
                                <i
                                    className="fa fa-info-circle blue cursor-pointer"
                                    aria-hidden="true"
                                    title={marketList[0].freeText}
                                    onClick={(e) => {
                                        showInfoNotification(
                                            marketList[0].freeText,
                                            e
                                        );
                                    }}
                                />
                            )}
                    </>
                )}

                <LinkShowAllMarkets
                    onClick={() => openGamePage(ev, userId)}
                    $visible={Boolean(marketCountLabel)}
                    $isMobile={isMobile}
                >
                    <span>{marketCountLabel}</span>
                </LinkShowAllMarkets>
                <LiveSreamIcon $visible={ev?.streamId} $isMobile={isMobile}>
                    {ev?.streamId && (
                        <img
                            src={liveIcon}
                            alt="Live Stream Icon"
                            className={`mobileLiveIcon ${
                                ev.sportId === 20 ? 'tennis' : ''
                            }`}
                        />
                    )}
                </LiveSreamIcon>
            </EventColRight>
        </ViewEventListItemBox>
    );
};

export default LiveEventListItem;
